export default "__VITE_ASSET__B2fVL3bx__"